export default "__VITE_ASSET__CLmskp_R__"